module.exports = __webpack_public_path__ + "img/SEL2450G.cc904397.jpg";